'use client';

import * as React from 'react';
import { Tabs as BaseTabs } from '@base-ui/react/tabs';
import styles from './Tabs.module.css';
import clsx from 'clsx';

export interface TabsProps {
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export interface TabListProps {
  children: React.ReactNode;
  className?: string;
}

export interface TabProps {
  value: string;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
}

export interface TabPanelProps {
  value: string;
  children: React.ReactNode;
  className?: string;
}

export const Tabs = React.forwardRef<HTMLDivElement, TabsProps>(
  ({ value, defaultValue, onChange, children, className }, ref) => {
    return (
      <BaseTabs.Root
        ref={ref}
        value={value}
        defaultValue={defaultValue}
        onValueChange={onChange}
        className={clsx(styles.root, className)}
      >
        {children}
      </BaseTabs.Root>
    );
  }
);

Tabs.displayName = 'Tabs';

export const TabList = React.forwardRef<HTMLDivElement, TabListProps>(
  ({ children, className }, ref) => {
    return (
      <BaseTabs.List ref={ref} className={clsx(styles.list, className)}>
        {children}
      </BaseTabs.List>
    );
  }
);

TabList.displayName = 'TabList';

export const Tab = React.forwardRef<HTMLButtonElement, TabProps>(
  ({ value, disabled, children, className }, ref) => {
    return (
      <BaseTabs.Tab
        ref={ref}
        value={value}
        disabled={disabled}
        className={clsx(styles.tab, className)}
      >
        {children}
      </BaseTabs.Tab>
    );
  }
);

Tab.displayName = 'Tab';

export const TabPanel = React.forwardRef<HTMLDivElement, TabPanelProps>(
  ({ value, children, className }, ref) => {
    return (
      <BaseTabs.Panel
        ref={ref}
        value={value}
        className={clsx(styles.panel, className)}
      >
        {children}
      </BaseTabs.Panel>
    );
  }
);

TabPanel.displayName = 'TabPanel';
